import React from 'react';
import { PencilIcon, TrashIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';

const ImportantNewsCard = ({ message, onEdit, onDelete }) => {
    return (
        <div className="bg-white rounded-xl border border-slate-200 p-6 hover:shadow-md transition-shadow">
            <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                    <div className="flex items-center gap-3 mb-3">
                        <span className="inline-flex items-center justify-center w-8 h-8 rounded-lg bg-red-100 text-red-600 font-bold text-sm">
                            {message.display_order}
                        </span>
                        <span className={`px-3 py-1 rounded-full text-xs font-bold ${message.is_active
                                ? 'bg-green-100 text-green-700'
                                : 'bg-gray-100 text-gray-700'
                            }`}>
                            {message.is_active ? 'Active' : 'Inactive'}
                        </span>
                    </div>
                    <p className="text-slate-800 leading-relaxed">
                        {message.message}
                    </p>
                    <p className="text-xs text-slate-400 mt-2">
                        {message.message.length}/500 characters
                    </p>
                </div>
                <div className="flex items-center gap-2">
                    <button
                        onClick={() => onEdit(message)}
                        className="p-2 text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                        title="Edit Message"
                    >
                        <PencilIcon className="h-5 w-5" />
                    </button>
                    <button
                        onClick={() => onDelete(message.id)}
                        className="p-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                        title="Delete Message"
                    >
                        <TrashIcon className="h-5 w-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ImportantNewsCard;
